import { components as UsersTypesComponents } from './users/users.types.generated'

export enum ERROR_KEYS {
  COMMON = 'site.something_wrong',
  RATE_LIMIT = 'api_error.rate_limit',
  FORBIDDEN = 'api_error.forbidden',
  NOT_FOUND = 'api_error.not_found',
  UNAUTHORIZED = 'api_error.unauthorized',
  BAD_REQUEST = 'api_error.bad_request',
  INVALID_PASSWORD_2FA = 'api_error.2fa_invalid_password',
  BLOCKED = 'cmn_authform.blocked-cause',
  INVALID_CODE = 'api_error.2fa_invalid_code',
  // Extra errors
  TRANSFER = 'api_error.signup_restricted_site',
  EMAIL_ALREADY_EXIST = 'api_error.signup_email_already_exist',
  PAYMENT_ACCOUNT_CONFIRMATION_TOKEN_IS_EXPIRED = 'payments.confirmation_token_is_expired',
}

export interface ResponseErrorInterface {
  error?: UsersTypesComponents['schemas']['Error']['error']
}
